import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './app/App';
import './styles/globals.css';
import 'react-toastify/dist/ReactToastify.css';

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
